import { Component, OnInit } from '@angular/core';
import {DiamondPayDataService} from "../diamond-pay-data-service.service";

@Component({
  selector: 'app-recurring-transactions',
  templateUrl: './matched-transactions.component.html',
  styleUrls: ['./matched-transactions.component.css'],
  providers: [DiamondPayDataService],
})
export class MatchedTransactionsComponent implements OnInit {
  private process_in_progress: boolean;
  private collection: any[];

  constructor(private dataService: DiamondPayDataService) { }

  ngOnInit() {
        this.process_in_progress = false;
        this.collection = [];
        this.dataService
            .RetrieveDiamondPayTransactions()
            .subscribe((data:any[]) => this.collection = data, error => console.log(error));
  }

  sendToCurrentBatch(diamond_pay_transactions) {
      this.process_in_progress = true;
      this.dataService.
                sendToCurrentBatch(diamond_pay_transactions.filter(log => log.selected == true)).
                subscribe((response) => this.ngOnInit());
  }

  selectAll(collection) {
      var anySelected = collection.filter(item => item.selected == true).length > 0;
      collection.forEach((item) => {
          item.selected = !anySelected;
      });
  }

  shouldDisable(collection) {
      return this.process_in_progress || collection.filter(log => log.selected == true).length == 0;
  }

}



// WEBPACK FOOTER //
// ./src/app/matched-transactions/matched-transactions.component.ts